import React, { Component } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Creators as PrizesActions } from 'store/ducks/prizes';

import { Page, Breadcrumbs } from 'components';
import { Form } from 'pages/Points/Prize/components';

class Create extends Component {
  state = {
    form: {
      goal: '',
      reward: '',
      active: true,
    },

    breadcrumbs: [
      { name: 'Home', to: '/' },
      { name: 'Pontos', to: '/points' },
      { name: 'Premiações', to: '/points/prizes' },
      { name: 'Novo', to: '' },
    ],
  };

  handleChange = data => {
    this.setState({ form: data });
  };

  handleSubmit = e => {
    e.preventDefault();

    const { form } = this.state;

    this.props.createPrizeRequest(form);
  };

  render() {
    const { form, breadcrumbs } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form data={form} saving={create.loading} onChange={this.handleChange} onSubmit={this.handleSubmit} />
      </Page>
    );
  }
}

const mapState = state => ({
  create: state.prizes.create,
});

const mapActions = dispatch => bindActionCreators(PrizesActions, dispatch);

export default connect(
  mapState,
  mapActions,
)(Create);
